import { render, staticRenderFns } from "./daily-cargo-driver-administration.vue?vue&type=template&id=f5519172"
import script from "./daily-cargo-driver-administration.vue?vue&type=script&lang=js"
export * from "./daily-cargo-driver-administration.vue?vue&type=script&lang=js"
import style0 from "./daily-cargo-driver-administration.vue?vue&type=style&index=0&id=f5519172&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports